import { CommonModule } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule, PLATFORM_ID, Provider } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { TRANSLATIONS } from './i18n-config';
import { createTranslateLoader } from './translate-loader/create-translate-loader';

@NgModule({
  exports: [TranslateModule],
  imports: [
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient, PLATFORM_ID, TRANSLATIONS],
      },
    }),
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class I18nModule {
  static forRoot(
    translationsProvider: Provider,
    defaultLanguageProvider: Provider,
    languagesProvider: Provider,
  ): ModuleWithProviders<I18nModule> {
    return {
      ngModule: I18nModule,
      providers: [translationsProvider, defaultLanguageProvider, languagesProvider],
    };
  }
}
